// extracted by mini-css-extract-plugin
module.exports = {"chartBlock":"ChartBlock_chartBlock__VF008","chart":"ChartBlock_chart__i-UJe","deleteBtn":"ChartBlock_deleteBtn__293lG"};